(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productsection-hotydesign"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ByJPT Filter Animation Handler
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggle = document.querySelector('.byjpt-catalog__filter-toggle');
    const filterPanel = document.querySelector('.byjpt-catalog__filters-panel');
    const filterOverlay = document.querySelector('.byjpt-catalog__filter-overlay');
    
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        filterPanel.classList.toggle('byjpt-catalog__filters-panel--active');
        filterOverlay.classList.toggle('byjpt-catalog__filter-overlay--active');
        document.body.classList.toggle('filter-panel-open');
      });
    }

    if (filterOverlay) {
      filterOverlay.addEventListener('click', function() {
        filterPanel.classList.remove('byjpt-catalog__filters-panel--active');
        filterOverlay.classList.remove('byjpt-catalog__filter-overlay--active');
        document.body.classList.remove('filter-panel-open');
      });
    }

    // Stagger animation for product cards
    const observerOptions = {
      threshold: 0.05,
      rootMargin: '0px 0px -50px 0px'
    };

    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('byjpt-catalog__product-card--visible');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.byjpt-catalog__product-card').forEach(card => {
      cardObserver.observe(card);
    });
    document.addEventListener('click',function(event){if(event.target.closest('a,button'))return;const image=event.target.closest('.byjpt-catalog__product-image-wrapper');if(!image)return;const card=image.closest('.byjpt-catalog__product-card');const link=card?card.querySelector('.byjpt-catalog__product-title a'):null;if(link)window.location.href=link.href;});
    
  });

 // Add to Cart functionality - SIMPLE VERSION
document.addEventListener('DOMContentLoaded', function() {
  // Solo agregamos un loading state básico sin prevenir el submit
  const productForms = document.querySelectorAll('.byjpt-product-form');
  
  productForms.forEach(form => {
    form.addEventListener('submit', function() {
      const button = this.querySelector('.byjpt-add-to-cart-btn');
      const buttonText = button.querySelector('.byjpt-button-text');
      const buttonLoading = button.querySelector('.byjpt-button-loading');
      
      // Mostrar estado de carga momentáneo
      buttonText.style.display = 'none';
      buttonLoading.style.display = 'inline';
      button.disabled = true;
      
      // El formulario se enviará normalmente y recargará la página
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text_blue"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const containers = document.querySelectorAll(".blur-text-section");

  containers.forEach(container => {
    const animateBy = container.dataset.animateBy;
    const delayStep = parseInt(container.dataset.delayStep || 200) / 1000; // ms → s

    const texts = container.querySelectorAll(".blur-text");

    texts.forEach(textBlock => {
      let spans = Array.from(textBlock.querySelectorAll("span"));

      // Si está configurado por letras → convertir palabras en letras
      if (animateBy === "letters") {
        const newSpans = [];
        spans.forEach(span => {
          const word = span.textContent;
          span.remove();
          word.split("").forEach(letter => {
            const letterSpan = document.createElement("span");
            letterSpan.textContent = letter === " " ? "\u00A0" : letter;
            textBlock.appendChild(letterSpan);
            newSpans.push(letterSpan);
          });
          // espacio entre palabras
          const spaceSpan = document.createElement("span");
          spaceSpan.textContent = "\u00A0";
          textBlock.appendChild(spaceSpan);
        });
        spans = newSpans;
      }

      // IntersectionObserver
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            spans.forEach((span, index) => {
              span.style.setProperty("--delay", `${index * delayStep}s`);
              span.classList.add("in-view");
            });
            observer.unobserve(textBlock);
          }
        });
      }, { threshold: 0.1 });

      observer.observe(textBlock);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
